export default {
  water2nd: '水の二局',
  wood3rd: '木の三局',
  metal4th: '金の四局',
  earth5th: '土の五局',
  fire6th: '火の六局',
} as const;
